import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-multi-point-input',
  templateUrl: './multi-point-input.component.html',
  styleUrls: ['./multi-point-input.component.scss'],
})
export class MultiPointInputComponent implements OnInit {
  points: string = ''; // Assuming you want to collect the text from the textarea

  constructor(private _modalController: ModalController) {}

  ngOnInit() {}

  closeModal() {
    this._modalController.dismiss();
  }

  submit() {
    // Collect the data you want to pass back
    const data = this.points;
    // Dismiss the modal and pass the data
    this._modalController.dismiss(data);
  }
}
